export const formatTime = (time?: string) => {
  if (!time) return "N/A";

  const date = new Date(time);
  if (isNaN(date.getTime())) return "Invalid Time";

  const hours = date.getHours();
  const minutes = date.getMinutes();

  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHour = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinute = minutes.toString().padStart(2, "0");

  return `${formattedHour}:${formattedMinute} ${ampm}`;
};

export const formatAttendenceTicketTime = (time: string): string => {
  if (!time || typeof time !== "string") return "N/A";

  // Check if it's already in 12-hour format with AM/PM
  const ampmRegex = /(\d{1,2}):(\d{2})\s?(AM|PM)/i;
  const ampmMatch = time.match(ampmRegex);

  if (ampmMatch) {
    // If it's already AM/PM, normalize the spacing and return it
    const hour = ampmMatch[1];
    const minute = ampmMatch[2];
    const period = ampmMatch[3].toUpperCase();
    return `${hour.padStart(2, "0")}:${minute} ${period}`;
  }

  // Handle 24-hour format (e.g., "18:40" or "06:30")
  const parts = time.split(":");
  let hour = parseInt(parts[0], 10);
  const minute = parseInt(parts[1], 10);

  if (isNaN(hour) || isNaN(minute)) return time;

  const ampm = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
  const formattedMinute = minute.toString().padStart(2, "0");

  return `${formattedHour.toString().padStart(2, "0")}:${formattedMinute} ${ampm}`;
};
